document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a.hanso-amz-cart') : null;
  const drawer = document.getElementById('cart-drawer');
  if (!link || !drawer || typeof drawer.open !== 'function') return;
  const badge = link.querySelector('[data-hanso-cart-count]');
  const shown = drawer.querySelector('.theme-drawer__badge');
  if (badge?.dataset.ready === 'true' && Number(badge.textContent.trim()) !== Number(shown?.textContent.trim() || 0)) return;
  event.preventDefault();
  drawer.open();
});
